export const getLoginLogoByDomain = () => {
    const domainLogoMapping = {
        'betbuzz24.live': { src: '/other/betbuzz24.png', style: { width: '80%', height: '15.33vw' } },
        'skyexch99.art': { src: '/other/logo.png', style: { width: '30%', height: '29.33vw' } },
        'skyexch.sbs': { src: '/other/logo.png', style: { width: '30%', height: '29.33vw' } },
    };

    // Get the current domain
    const currentDomain = window.location.hostname;

    // Return the corresponding logo or a default one
    return domainLogoMapping[currentDomain] || { src: '/other/logo.png', style: { width: '30%', height: '29.33vw' } };
};
